<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <el-input
        v-model="tableParams.searchKey"

        placeholder="搜索创意标题/描述等"
      />
      <el-select
        v-model="tableParams.dspId"

        clearable
        placeholder="所属预算"
        style="margin-right: 15px"
      >
        <el-option
          v-for="item in statusList"
          :label="item.dspName"
          :value="item.dspId"
          :key="item.dspId"
        />
      </el-select>
      <el-select
        v-model="tableParams.creativeType"

        clearable
        placeholder="创意类型"
        style="margin-right: 15px"
      >
        <el-option
          v-for="item in creativeTypeList"
          :label="item.lable"
          :value="item.value"
          :key="item.value"
        />
      </el-select>
      <el-select
          v-model="tableParams.tpid"
          placeholder="所有创意尺寸"
          clearable

          style="margin-right: 15px"
        >
          <el-option
            v-for="item in template"
            :key="item.tpid"
            :label="item.imgStandard"
            :value="item.tpid"
          >
          </el-option>
        </el-select>
      <el-select
        v-model="tableParams.creativeStatus"

        clearable
        placeholder="审核状态"
        style="margin-right: 15px"
      >
        <el-option
          v-for="item in creativeStatusList"
          :label="item.lable"
          :value="item.value"
          :key="item.value"
        />
      </el-select>
      <el-select
        v-model="tableParams.cert"

        clearable
        placeholder="第三方审核状态"
        style="margin-right: 15px"
      >
        <el-option
          v-for="item in certList"
          :label="item.lable"
          :value="item.value"
          :key="item.value"
        />
      </el-select>
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>
    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px"
      >
      </table-column>
      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{ background: '#fafafa' }"
        highlight-current-row
        size="small"
        class="js-table"
        style="width: 100%"
      >
        <el-table-column
          v-for="(v, i) in checkColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          :min-width="v.minWidth"
          :key="i"
          align="center"
        >
          <template v-slot="scope">
            <template v-if="v.field === 'imgUrl'">
              <el-image
                v-if="scope.row[v.field]"
                :src="$imgURL + scope.row[v.field]"
                style="width:100px"
                alt="广告截图"
              >
               <template #error>
                    <div class="image-slot">
                      <span>-</span>
                    </div>
                  </template>
              </el-image>
              <span v-else>-</span>
            </template>
            <template v-else-if="v.field === 'landingPage'">
              <el-image
                v-if="scope.row[v.field]"
                :src="$imgURL + scope.row[v.field]"
                style="width:100px"
              >
               <template #error>
                    <div class="image-slot">
                      <span>-</span>
                    </div>
                  </template>
              </el-image>
              <span v-else>-</span>
            </template>
            <template v-else-if="v.field === 'title'">
              <div>{{ scope.row.title }}</div>
              <div>{{ scope.row.textDesc }}</div>
            </template>
            <template v-else-if="v.field === 'creativeStatus'">
              <span v-if="scope.row.creativeStatus == 1">已通过</span>
              <span v-else-if="scope.row.creativeStatus == 2">未通过</span>
              <span v-else>未审核</span>
            </template>
            <template v-else-if="v.field === 'cert'">
              <div v-if="scope.row.cert == 1">已通过</div>
              <div v-else-if="scope.row.cert == 2">未通过</div>
              <div v-else-if="scope.row.cert == 3">
                <el-popover
                  placement="bottom"
                  @show="auditList(scope.row.creativeId)"
                  width="60%"
                  ref="popover"
                  trigger="hover"
                >
                  <template #reference>
                    <span>部分通过</span>
                  </template>
                  <el-table :data="auditData">
                    <el-table-column
                      property="channelId"
                      label="渠道编号"
                    ></el-table-column>
                    <el-table-column
                      property="channelName"
                      label="渠道姓名"
                    ></el-table-column>
                      <el-table-column label="状态">
                        <template v-slot="scope">
                            <div v-if="scope.row.channelVerifyStatus==0">未审核</div>
                            <div v-if="scope.row.channelVerifyStatus==1">已通过</div>
                            <div v-if="scope.row.channelVerifyStatus==2">未通过</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                      property="lastUpdateTime"
                      width="160"
                      label="最后审核时间"
                    ></el-table-column>
                    <el-table-column
                      property="verifyMsg"
                      label="原因"
                    ></el-table-column>
                  </el-table>
                  <el-pagination small layout="prev, pager, next" :total="auditTotal" page-size="6" :current-page="aform.pageNum"
                  @current-change="pageChange"> </el-pagination>
                </el-popover>
              </div>
              <div v-else-if="scope.row.cert == 4">
                <el-popover
                  placement="bottom"
                  @show="auditList(scope.row.creativeId)"
                  width="60%"
                  ref="popover"
                  trigger="hover"
                >
                  <template #reference>
                    <span>部分未通过</span>
                  </template>
                  <el-table :data="auditData">
                    <el-table-column
                      property="channelId"
                      label="渠道编号"
                    ></el-table-column>
                    <el-table-column
                      property="channelName"
                      label="渠道姓名"
                    ></el-table-column>
                      <el-table-column label="状态">
                        <template v-slot="scope">
                            <div v-if="scope.row.channelVerifyStatus==0">未审核</div>
                            <div v-if="scope.row.channelVerifyStatus==1">已通过</div>
                            <div v-if="scope.row.channelVerifyStatus==2">未通过</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                      property="lastUpdateTime"
                      width="160"
                      label="最后审核时间"
                    ></el-table-column>
                    <el-table-column
                      property="verifyMsg"
                      label="原因"
                    ></el-table-column>
                  </el-table>
                  <el-pagination small layout="prev, pager, next" :total="auditTotal" page-size="6" :current-page="aform.pageNum"
                  @current-change="pageChange"> </el-pagination>
                </el-popover>
              </div>
              <div v-else>未审核</div>
            </template>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          align="center"
          width="100px"
        >
          <template v-slot="scope" align="center">
            <el-button type="success" size="mini" @click="openForm(scope.row)"
              >审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px"
      />
    </div>
    <my-andit ref="form" @submit="renew"> </my-andit>
  </div>
</template>

<script>
import TableColumn from "@/components/TableColumn";
import initTableMixin from "@/mixins/initTable";
import myAndit from "./andit.vue";
import { getDspName} from '@/api/select'
import { getAuditList,getTemplate } from "@/api/manage/creative/creative";
export default {
  name: 'managerCreativeAudit',
  mixins: [initTableMixin],
  components: {
    TableColumn,
    myAndit,
  },
  data() {
    return {
      columns: [
        { field: "creativeId", title: "创意ID" },
        { field: "slotTypeName", title: "创意类型" },
        { field: "imgUrl", title: "创意预览图" },
        { field: "title", title: "文字" },
        { field: "landingPage", title: "创意落地页" },
        { field: "imgStandard", title: "尺寸" },
        { field: "dspName", title: "所属预算" },
        { field: "lastUpdateTime", title: "创意更新时间" },
        { field: "creativeStatus", title: "状态" },
        { field: "cert", title: "第三方审核状态" },
        { field: "creativeDescribe", title: "拒绝原因" },
      ],
      template: [],
      statusList:[],
      creativeTypeList: [
        { value: 1, lable: "开屏" },
        { value: 2, lable: "信息流" },
        { value: 3, lable: "插屏" },
        { value: 4, lable: "Banner" },
        { value: 5, lable: "激励视频" },
      ],
      templateList: [
        { value: 1, lable: "640*360" },
        { value: 2, lable: "600*800" },
        { value: 3, lable: "700*1000" },
        { value: 4, lable: "800*1200" },
        { value: 5, lable: "1000*1400" },
      ],
      creativeStatusList: [
        { value: 4, lable: "所有状态" },
        { value: 0, lable: "未审核" },
        { value: 1, lable: "已通过" },
        { value: 2, lable: "未通过" },
      ],
      certList: [
        { value: 0, lable: "未审核" },
        { value: 1, lable: "已通过" },
        { value: 2, lable: "未通过" },
        { value: 3, lable: "部分通过" },
        { value: 4, lable: "部分未通过" },
      ],
      tableParams: {
        searchKey: "",
        dspId: "",
        creativeStatus: "",
        creativeType: "",
        tpid: "",
        cert: "",
      },
      auditData:undefined,
      auditTotal:undefined,
      aform: {
        pageNum:1,
        pageSize: 6,
        creativeId: undefined,
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  created(){
    getDspName({ dspType: 1 }).then((res) => {
      this.statusList = res.data;
    });
    getTemplate().then((res) => {
      this.template = res.data;
    });
  },
  methods: {
    beforeInit() {
      this.tableUrl = "/creative/creative/status/list";
      return true;
    },
    toQuery() {
      this.pagination.pageNum = 1;
      if (
        !this.isTime &&
        (this.tableParams.asc === "timeHour" ||
          this.tableParams.desc === "timeHour")
      ) {
        this.tableParams.asc = "";
        this.tableParams.desc = "";
      }
      this.init();
    },
    openForm(row) {
      this.$refs.form.show(row);
    },
    renew() {
      this.currentChange(this.pagination.pageNum);
    },
    pageChange(pageNum){
      this.aform.pageNum=pageNum;
      let id=false;
      this.auditList(id,pageNum)
    },
    auditList(id,page) {
      if(id){
        this.aform.creativeId=id;
      }
      getAuditList(this.aform).then((res) => {
        this.auditData=res.data.records
        this.auditTotal=res.data.total
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;
  & > * {
    margin-right: 15px;
    margin-bottom: 10px;
    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select & > .base-date-picker {
    width: 400px;
  }
  & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;
  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
</style>
